var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "tips"
  }, [_vm._v("*" + _vm._s(_vm.$t("密码需由8-16位数字、大小写字母组成")))]), _c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("新密码"),
      prop: "password"
    }
  }, [_c("a-input-password", {
    ref: "password",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("新密码"),
      size: "large",
      "allow-clear": "",
      maxLength: 16
    },
    on: {
      input: function ($event) {
        _vm.form.password = _vm.form.password.replace(/\s/g, "");
      }
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  }, [_c("svg-icon", {
    attrs: {
      slot: "prefix",
      icon: "password",
      size: 14
    },
    slot: "prefix"
  })], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("确认密码"),
      prop: "password_confirmation"
    }
  }, [_c("a-input-password", {
    ref: "confirmPassword",
    attrs: {
      placeholder: _vm.$t("请再次输入") + _vm.$t("新密码"),
      size: "large",
      "allow-clear": "",
      maxLength: 16
    },
    on: {
      input: function ($event) {
        return _vm.handleBlurTrim("password_confirmation");
      }
    },
    model: {
      value: _vm.form.password_confirmation,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password_confirmation", $$v);
      },
      expression: "form.password_confirmation"
    }
  }, [_c("svg-icon", {
    attrs: {
      slot: "prefix",
      icon: "password",
      size: 14
    },
    slot: "prefix"
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };